function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15 0C6.7 0 0 6.7 0 15s6.7 15 15 15 15-6.7 15-15S23.3 0 15 0zm0 28.5c-7.5 0-13.5-6-13.5-13.5S7.5 1.5 15 1.5s13.5 6 13.5 13.5-6 13.5-13.5 13.5zm.1-13.7l6 7-.6.6-7.8-6.8.8-10.3h.8l.8 9.5z",
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd"
})));